import React from "react";
import Slider from "react-slick";
import { Quote } from "lucide-react";
import backgroundImage from "images/service.png";

const testimonials = [
  {
    company: "Navkar Laminates",
    text: "Navkar Laminates are not just products. They are a testament to quality and innovation. Their attention to detail and customer service is exceptional.",
    author: " - NAVKAR LAMINATES"
  },
  {
    company: "Navkar Laminates",
    text: "Great service and top-notch quality. Always a pleasure to work with this team!",
    author: "- NAVKAR LAMINATES"
  },
  {
    company: "Navkar Laminates",
    text: "The team at Navkar Laminates is professional and dedicated. Their products have transformed our space.",
    author: "- NAVKAR LAMINATES"
  },
];

const Testimonial = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    pauseOnHover: true,
  };

  return (
    <section
      className="relative bg-cover bg-center bg-fixed bg-no-repeat text-white py-16 px-4 md:px-20"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/* Dark Overlay */}
                <div className="absolute inset-0 bg-black/70 z-0"></div>
      <div className="relative z-10 max-w-[1200px] mx-auto text-center">
        <Slider {...settings}>
          {testimonials.map((item, index) => (
            <div key={index} className="px-6">
              <Quote size={40} className="mx-auto text-white mb-4" />
              <h2 className="text-white text-xl md:text-2xl font-semibold mb-4">
                - {item.company} -
              </h2>
              <p className="italic text-sm md:text-base leading-relaxed mb-4">
                {item.text}
              </p>
              <p className="text-sm md:text-base font-semibold uppercase text-gray-300">
                {item.author}
              </p>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonial;
